import type { HekateFormSubmit } from '@onshape/www-inertia';
import BaseProgressiveProfile from './BaseProgressiveProfile';

export default class DefaultProgressiveProfile extends BaseProgressiveProfile {
  public onClient(): void {
    const bus = useHekateEventBus();
    const { setPersistedProgressiveProfileFromFormSubmit } = useWwwStorage();
    bus.addEventListener('form-successfully-submitted', (event) => {
      const formDefinition = event.data.formDefinition as HekateFormSubmit;

      setPersistedProgressiveProfileFromFormSubmit({ formDefinition });
    });
  }

  public onSsg(): Promise<void> {
    return Promise.resolve();
  }
}
